import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(
    private _http: HttpClient
  ) { }

  public getCoupons():Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/stripe/coupons').pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
